import * as z from "zod";
import * as b from './baseSchemas';
export const blazonTypes = z.enum([
    'Earth',
    'Wind',
    'Fire',
    'Ocean',
    'Light',
    'Shadow',
]);
export const blazonSet = z.enum([
    'Justice',
    'Valor',
    'Honor',
    'Honesty',
    'Sacrifice',
    'Compassion',
    'Soul',
    'Humility',
]);
export const BlazonSchema = z.object({
    blazon: z.object({
        type: blazonTypes,
        set: blazonSet,
        level: b.levels,
        buff: z.union([b.Buff, z.array(b.Buff)])
    })
});
export const BlazonSetSechma = z.object({
    set: z.object({
        earth: BlazonSchema.refine((b) => b.blazon.type === 'Earth').nullish(),
        wind: BlazonSchema.refine((b) => b.blazon.type === 'Wind').nullish(),
        fire: BlazonSchema.refine((b) => b.blazon.type === 'Fire').nullish(),
        ocean: BlazonSchema.refine((b) => b.blazon.type === 'Ocean').nullish(),
        light: BlazonSchema.refine((b) => b.blazon.type === 'Light').nullish(),
        shadow: BlazonSchema.refine((b) => b.blazon.type === 'Shadow').nullish()
    })
});
